import React from 'react';
import gql from 'graphql-tag';

import { SHOP_PATH } from '@reverbdotcom/commons/src/url_helpers';

import { CoreShopContainer } from '../../../schemas/rql';

export const ShopMetadataFragment = gql`
  fragment ShopMetadataFragment on Shop {
    _id
    name
    slug
    user {
      _id
      feedbackSummary {
        rollingRatingPercentage
        receivedCount
      }
    }
  }
`;

interface IProps {
  shop: CoreShopContainer.Shop;
}

export default class ShopMetadata extends React.Component<IProps, null> {
  render() {
    const { shop } = this.props;

    if (!shop) return null;

    const ratingCount = shop.user?.feedbackSummary?.receivedCount ?? 0;

    return (
      <div
        itemScope
        itemType="https://schema.org/Store"
      >
        <meta
          itemProp="name"
          content={shop.name}
        />
        <meta
          itemProp="url"
          content={SHOP_PATH.expand({ slug: shop.slug })}
        />
        {ratingCount > 0 &&
          <div
            itemProp="aggregateRating"
            itemType="http://schema.org/AggregateRating"
            itemScope
          >
            <meta
              itemProp="name"
              content={shop.name}
            />
            <meta
              itemProp="ratingValue"
              content={`${(shop.user?.feedbackSummary?.rollingRatingPercentage / 100) * 5}`}
            />
            <meta
              itemProp="ratingCount"
              content={`${ratingCount}`}
            />
            <meta
              itemProp="bestRating"
              content="5"
            />
            <meta
              itemProp="worstRating"
              content="0"
            />
          </div>
        }
      </div>
    );
  }
}
